import { ACTION_STATUS } from "../actionbar-detail.constant";
import { ButtonBase } from "./button.base";

export class ActionButtonModel extends ButtonBase {
    label: string = 'Action';
    action: string = ACTION_STATUS.action;
    matIconName: string = 'tune';
    colorClass: string = 'color-primary-500';
}